import { render, staticRenderFns } from "./OffersSlider.vue?vue&type=template&id=131ca6ee&scoped=true"
import script from "./OffersSlider.vue?vue&type=script&lang=js"
export * from "./OffersSlider.vue?vue&type=script&lang=js"
import style0 from "./OffersSlider.vue?vue&type=style&index=0&id=131ca6ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131ca6ee",
  null
  
)

export default component.exports